import { MtStudySession } from "server/models"
import { OrderType, inferLiteral } from "client/utils"
import * as types from "./types"

export const setStudySessionBaseRoute = (baseRoute: string) => ({
    type: inferLiteral(types.STUDY_SESSION_BASE_ROUTE),
    baseRoute,
})


export const setStudySessionList = (sessionList: types.StudySessionList) => ({
    type: inferLiteral(types.STUDY_SESSION_LIST),
    sessionList,
})
export const setStudySessionListByStudy = (sessionListByStudy: types.StudySessionListByStudy) => ({
    type: inferLiteral(types.STUDY_SESSION_LIST_BY_STUDY),
    sessionListByStudy,
})
export const setStudySessionIds = (sessionIds: readonly number[]) => ({
    type: inferLiteral(types.STUDY_SESSION_IDS),
    sessionIds,
})
export const setStudySessionView = (session: MtStudySession) => ({
    type: inferLiteral(types.STUDY_SESSION_VIEW),
    session,
})
export const setStudySessionEdit = (session: MtStudySession) => ({
    type: inferLiteral(types.STUDY_SESSION_EDIT),
    session,
})


export const setStudySessionAttendance = (sessionAttendance: types.StudySessionAttendance) => ({
    type: inferLiteral(types.STUDY_SESSION_ATTENDANCE),
    sessionAttendance,
})


export const setStudySessionSort = (sortColumn: keyof MtStudySession, sortOrder: OrderType) => ({
    type: inferLiteral(types.STUDY_SESSION_SORT),
    sortColumn,
    sortOrder,
})
export const setStudySessionFilters = (filters: types.StudySessionFilters) => ({
    type: inferLiteral(types.STUDY_SESSION_FILTERS),
    filters,
})


export const setStudySessionReloadList = (value: boolean) => ({
    type: inferLiteral(types.STUDY_SESSION_RELOAD_LIST),
    value,
})
export const setStudySessionReloadView = (value: boolean) => ({
    type: inferLiteral(types.STUDY_SESSION_RELOAD_VIEW),
    value,
})
export const setStudySessionReloadEdit = (value: boolean) => ({
    type: inferLiteral(types.STUDY_SESSION_RELOAD_EDIT),
    value,
})
